<template>
  <div>
    <modal-layout-top :title="title" />
    <div class="content slider-modal">
      <div class="field">
        <label class="label">Loggmeddelande</label>
        <input class="input" type="text" v-model="log.message" />
      </div>
      <modal-layout-buttons hideClose :saveLabel="'Spara'" :store-name="'logs'" />

      <div v-if="logLoaded" class="logTable">
        <div class="columns logHead">
          <div class="column is-1">
            <strong>Initialer</strong>
          </div>
          <div class="column is-2">
            <strong>Typ</strong>
          </div>
          <div class="column is-3">
            <strong>Skapat datum</strong>
          </div>
            <div class="column is-1">
            <strong>Visa</strong>
          </div>
          <div class="column is-5">
            <strong>Meddelande</strong>
          </div>
        </div>
        <div class="logBody">
          <div class="columns logRow" v-for="item in getLogs" :key="item.projectLogId">
            <div class="column is-1" >
              {{ item.userInitials }}
            </div>
            <div class="column is-2">
              {{ item.logType }}
              <i
                v-if="item.logType === 'Manuell' && (item.userInitials === currentUser || isSuperAdmin)"
                class="fal fa-edit is-icon-link"
                @click="editLog(item)"
              ></i>
              <i
                v-if="item.logType === 'Manuell' && (item.userInitials === currentUser || isSuperAdmin)"
                class="fal fa-trash is-icon-link"
                @click="deleteLog(item.projectLogId)"
              ></i>

            </div>
            <div class="column is-3">
              {{ item.dateCreated | moment('YYYY-MM-DD HH:mm:ss') }}
            </div>
            <!-- <div class="column is-1">
              <i class="fal fa-external-link is-icon-link" v-if="item.message.indexOf('Kontakt') > -1" @click="$router.push({ name: 'Contact_Details', params: { contactId: item.contextId} })"></i>
              <i class="fal fa-external-link is-icon-link" v-if="item.message.indexOf('Adress') > -1" @click="$router.push({ name: 'Address_Details', params: { addressId: item.contextId} })"></i>
              <i class="fal fa-external-link is-icon-link" v-if="item.logType === 'Insats'" @click="$router.push({ name: 'WorkOrder_Details', params: { workOrderId: item.contextId} })"></i>
              <i class="fal fa-external-link is-icon-link" v-if="item.logType === 'Faktura'" @click="$router.push({ name: 'Invoice_Details', params: { invoiceId: item.contextId} })"></i>
              <i class="fal fa-external-link is-icon-link" v-if="item.logType === 'Leverans'" @click="$router.push({ name: 'Delivery_Details', params: { deliveryId: item.contextId} })"></i>
            </div> -->
            <div class="column is-4">
              {{ item.message }}
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalLayoutTop from '@/components/modals/ModalLayoutTop'
import ModalLayoutButtons from '@/components/modals/ModalLayoutButtons'

export default {
  name: 'project-log-modal',
  data () {
    return {
      log: {},
      items: { },
      logLoaded: false,
      title: 'Projektlogg',
      logId: null
    }
  },
  components: {
    ModalLayoutTop,
    ModalLayoutButtons
  },
  props: {
    id: {
      type: Number,
      required: false
    }
  },
  computed: {
    ...mapState({
      logs: state => state.logs.all
    }),
    getLogs: function () {
      return this.logs.items
    },
    currentUser: function () {
      return JSON.parse(localStorage.getItem('user')).initials
    },
    isSuperAdmin: function () {
      let role = JSON.parse(localStorage.getItem('user')).role
      return role === 'Developer' || role === 'SuperAdmin'
    }

  },
  methods: {
    ...mapActions('logs', ['update', 'create', 'getByProjectId', 'delete']),
    closePanel () {
      this.$emit('closePanel')
    },
    loadLogItems () {
      this.getByProjectId(this.id).then(() => {
        this.logLoaded = true
      })
    },
    editLog (log) {
      this.log = log
      this.logId = log.projectLogId
    },
    deleteLog (logId) {
      this.$confirm('Radera loggmeddelande', 'Är du säker på att du vill radera loggmeddelandet permanent?').then((result) => {
        if (result.value) {
          this.delete(logId).then(() => {
            this.logId = null
            this.log.message = ''
          })
        }
      })
    },
    save () {
      if (this.logId !== null) {
        this.update(this.log).then(() => {
          this.loadLogItems()
        })
      } else {
        if (this.log.message !== undefined) {
          this.log.projectId = this.id
          this.create(this.log).then(() => {
            this.loadLogItems()
            this.log.message = ''
          })
        } else {
          this.$alert('Loggmeddelandet är tomt!')
        }
      }
    }
  },
  created () {
    this.$on('emitSave', () => {
      this.save()
    })

    this.loadLogItems()
  }
}
</script>
<style>
  .logHead {
    background-color: #ACE;
  }

  .logBody .logRow:nth-child(odd) {
    background-color: #f2f2f2;
  }
  .logTable {
    margin-top: 2em;
    border-radius: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/components/modals/ProjectLogModal.vue